import React, { useEffect, useState } from "react";
import {
  CustomAutocomplete,
  CustomInput,
  CustomSelect,
} from "../../../../../../../../Components";
import { Box } from "@material-ui/core";
import { useTranslate } from "../../../../../../../../Hooks";
import {
  GetAllBranches,
  GetAllLMSCourses,
  GetTeam,
} from "../../../../../../../../Services";
import { useVerticalNav } from "../../../../../../../../Contexts/VerticalNavContext";
import { LearningHubLocalePath } from "../../../../../../LearningHub/i18n/LearningHub";
import { useDebouncedAction } from "../../../../../../../../Hooks/DebouncedAction";

// styles
import useStyle from "./styles";

function FilterSectionAgentCourseQualifications({ filter, setFilter }) {
  const styles = useStyle();
  const { translate } = useTranslate("NewPropertiesView");
  const { setAlertBoxContent } = useVerticalNav();
  const [data, setData] = useState({
    courses: [],
    teams: [],
    branches: [],
  });

  const [selected, setselected] = useState({
    courses: null,
    teams: null,
    branches: null,
    badge: null,
    staffID: null,
    agentName: null,
  });

  const setDataHandler = (field, value) => {
    setData((prevData) => ({ ...prevData, [field]: value }));
  };

  const setSelectedOptionHandler = (field, value) => {
    setselected((prevData) => ({ ...prevData, [field]: value }));
  };

  const getCourses = async (search) => {
    try {
      const result = await GetAllLMSCourses({
        pageIndex: 1,
        pageSize: 100,
        search,
      });
      if (result) {
        setDataHandler("courses", result);
      }
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("something_went_wrong", { ns: LearningHubLocalePath }),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    }
  };

  const getAllBranches = async (value) => {
    const res = await GetAllBranches({
      pageSize: 25,
      pageIndex: 1,
      branchName: value,
    });
    if (!(res && res.status && res.status !== 200)) {
      setDataHandler("branches", res.result);
    }
  };

  const getTeams = async (searchItem) => {
    const res = await GetTeam(1, 25, searchItem || "");

    if (!(res && res.status && res.status !== 200))
      setDataHandler("teams", res.result);
  };

  const getCoursesDebounced = useDebouncedAction(getCourses);
  const getAllBranchesDebounced = useDebouncedAction(getAllBranches);
  const getTeamsDebounced = useDebouncedAction(getTeams);
  const setFilterDebounced = useDebouncedAction(setFilter);

  useEffect(() => {
    getCourses();
    getAllBranches();
    getTeams();
  }, []);

  return (
    <Box className={styles.wrapperFiltersSections}>
      <Box className={styles.wrapperInput}>
        <CustomAutocomplete
          placeholder={translate("Courses")}
          options={data.courses}
          value={selected?.courses || null}
          onChange={(e, value) => {
            setFilter((prev) => ({
              ...prev,
              lmsCourseId: value?.lmsCourseId || null,
            }));
            setSelectedOptionHandler("courses", value);
          }}
          onInputKeyUp={(e) => {
            getCoursesDebounced(e.target.value);
          }}
          getOptionLabel={(option) => option?.lmsCourseName}
          getOptionValue={(option) => option?.lmsCourseName}
          renderOption={(option) => option?.lmsCourseName}
        />
      </Box>
      <Box className={styles.wrapperInput}>
        <CustomAutocomplete
          placeholder={translate("Branches")}
          options={data.branches}
          value={selected?.branches || null}
          onChange={(e, value) => {
            setFilter((prev) => ({
              ...prev,
              branchId: value?.branchId || null,
            }));
            setSelectedOptionHandler("branches", value);
          }}
          onInputKeyUp={(e) => {
            getAllBranchesDebounced(e.target.value);
          }}
          getOptionLabel={(option) => `${option.branchName || ""}`}
          getOptionValue={(option) => option.branchName || ""}
          renderOption={(option) => option.branchName || ""}
        />
      </Box>
      <Box className={styles.wrapperInput}>
        <CustomAutocomplete
          placeholder={translate("Teams")}
          options={data.teams}
          value={selected?.teams || null}
          onChange={(e, value) => {
            setFilter((prev) => ({
              ...prev,
              teamId: value?.teamsId || null,
            }));
            setSelectedOptionHandler("teams", value);
          }}
          onInputKeyUp={(e) => {
            getTeamsDebounced(e.target.value);
          }}
          getOptionLabel={(option) => option.teamsName || option.teamName || ""}
          getOptionValue={(option) => option.teamsName || option.teamName || ""}
          renderOption={(option) => option.teamsName || option.teamName || ""}
        />
      </Box>
      <Box className={styles.wrapperInput}>
        <CustomSelect
          style={{ width: "100%" }}
          placeholder={translate("Badge")}
          options={[
            { id: 1, name: "Community" },
            { id: 2, name: "Developer" },
            { id: 3, name: "Project" },
          ]}
          defaultValue={filter?.badgeFilter || null}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          onValueChange={(newValue) => {
            setFilter((prev) => ({ ...prev, badgeFilter: newValue }));
            setSelectedOptionHandler("badge", newValue);
          }}
          emptyItem={{
            id: null,
            name: "Select Badge",
            isDisabled: false,
          }}
        />
      </Box>
      <Box className={styles.wrapperInput}>
        <CustomInput
          hasSearchIcon={false}
          placeholder={translate("Staff-ID")}
          value={selected?.staffID || null}
          onChange={(e) => {
            e.persist();
            setFilterDebounced((prev) => ({
              ...prev,
              staffCode: e?.target?.value || null,
            }));
            setSelectedOptionHandler("staffID", e.target.value);
          }}
        />
      </Box>
      <Box className={styles.wrapperInput}>
        <CustomInput
          hasSearchIcon={false}
          placeholder={translate("Agent-name")}
          value={selected?.agentName || null}
          onChange={(e) => {
            e.persist();
            setFilterDebounced((prev) => ({
              ...prev,
              agentName: e?.target?.value || null,
            }));
            setSelectedOptionHandler("agentName", e.target.value);
          }}
        />
      </Box>
    </Box>
  );
}

export default FilterSectionAgentCourseQualifications;
